import { X } from "lucide-react";

interface Props {
  params: URLSearchParams;
  onDismiss: () => void;
}

export default function StatusBanner({ params, onDismiss }: Props) {
  const connected = params.get("connected");
  const error = params.get("error");
  if (!connected && !error) return null;

  return (
    <div
      className={`rounded-xl border p-3 mb-6 text-sm flex items-center justify-between ${
        connected
          ? "border-green-400/40 bg-green-50 dark:bg-green-950/30 text-green-700 dark:text-green-400"
          : "border-red-400/40 bg-red-50 dark:bg-red-950/30 text-red-700 dark:text-red-400"
      }`}
    >
      <span>
        {connected
          ? "Gmail connected successfully."
          : `Gmail connection failed: ${error}`}
      </span>
      <button onClick={onDismiss} className="ml-3 opacity-60 hover:opacity-100">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
